function createNamedResendTokenReducer(name = "") {
  return (state = {}, action) => {
    if (action != null) {
      switch (action.type) {
        case `RESEND_REQUEST_${name}`:
          return { requested: true };
        case `RESEND_FAILURE_${name}`:
          return { error: true };
        case `RESEND_SUCCESS_${name}`:
          return { success: true };
        default:
          return state;
      }
    }
  };
}

export const resendTokenFromLogin = createNamedResendTokenReducer("LOGIN");
export const resendTokenFromExpiredToken = createNamedResendTokenReducer(
  "TOKEN"
);
